<template>
    <div style="height: 0;">
        <el-dialog
                :append-to-body="true"
                :before-close="dialogCancle"
                :close-on-click-modal="true"
                :title="title"
                :visible.sync="dialogVisibleCopy"
                top="5vh"
                width="400px">
            <slot></slot>
        </el-dialog>
        <el-drawer
                :before-close="dialogCancle"
                :title="title"
                :visible.sync="drawerVisibleCopy"
                direction="rtl"
                size="425px">
            <slot></slot>
        </el-drawer>
    </div>
</template>

<script>


    export default {
        name: 'index',
        props: {
            dialogVisible: {
                type: Boolean,
                default:false
            },
            searchType: {
                type: String,
                default:'drawer'
            },
            title: {type: String},
        },
        computed:{
            dialogVisibleCopy:function () {
                return this.dialogVisible && this.searchType == 'dialog';
            },
            drawerVisibleCopy:function () {
                return this.dialogVisible && this.searchType == 'drawer';
            },
        },
        watch:{

        },

        data() {
            return {
                dialogVisibleCopy1:'',
            }
        },
        methods: {
            //关闭弹窗
            dialogCancle() {
                this.$emit('dialogCancle', false);
            },

        }
    }
</script>

<style scoped>
</style>
